module.exports = __webpack_public_path__ + "media/images/front/event_publish_lp/icon_pagetop_01-ea028055cf129b3a44bb67d329959f57.png";